import { useState } from "react";
import {
  FaChevronCircleLeft,
  FaChevronCircleRight,
  FaQuoteLeft,
  FaStar,
} from "react-icons/fa";
import testimonialUserImg from "../../../assets-user/testimonialUser.png";

const HomeTestimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const testimonials = [
    {
      id: 1,
      quote:
        "LeadBook helped us reach serious buyers directly. Our new project sold faster, without wasting time on fake leads. Really a very useful platform.",
      name: "Aditya Singh",
      company: "ASK Builders",
      rating: 4,
      image: testimonialUserImg,
    },
    {
      id: 2,
      quote:
        "Unlike other portals, every lead I get from LeadBook is verified and responsive. My closures have doubled in just three months.",
      name: "Diya Ray",
      company: "ABC Builders",
      rating: 5,
      image: testimonialUserImg,
    },
    {
      id: 3,
      quote:
        "LeadBook helped us reach serious buyers directly. Our new project sold faster, without wasting time on fake leads. Really a very useful platform.",
      name: "MS Singh",
      company: "MS Builders",
      rating: 4,
      image: testimonialUserImg,
    },
    {
      id: 4,
      quote:
        "LeadBook helped us reach serious buyers directly. Our new project sold faster, without wasting time on fake leads. Really a very useful platform.",
      name: "Rikki Singh",
      company: "All Builders",
      rating: 4,
      image: testimonialUserImg,
    },
    {
      id: 5,
      quote:
        "LeadBook helped us reach serious buyers directly. Our new project sold faster, without wasting time on fake leads. Really a very useful platform.",
      name: "Aman Singh",
      company: "Amn Builders",
      rating: 4,
      image: testimonialUserImg,
    },
  ];

  const itemsToShow = 3;
  const maxIndex = Math.max(0, testimonials.length - itemsToShow);

  const nextTestimonial = () => {
    setCurrentIndex((prevIndex) => Math.min(prevIndex + 1, maxIndex));
  };

  const prevTestimonial = () => {
    setCurrentIndex((prevIndex) => Math.max(prevIndex - 1, 0));
  };

  const visibleTestimonials = testimonials.slice(
    currentIndex,
    currentIndex + itemsToShow
  );

  const renderStars = (rating) => {
    return (
      <div className="flex gap-1">
        {[...Array(5)].map((_, index) => (
          <FaStar
            key={index}
            className={`w-4 h-4 ${
              index < rating ? "text-yellow-400" : "text-gray-300"
            }`}
          />
        ))}
      </div>
    );
  };

  return (
    <div className="px-4 sm:px-6 md:px-8 lg:px-10 pb-6 sm:pb-6 md:pb-8 lg:pb-10 bg-white">
      <div className="mx-auto">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="font-medium text-[#031722] tracking-[0.01em] leading-[150%] text-lg sm:text-xl md:text-2xl lg:text-3xl mb-4">
              What People Tell About Us
            </h2>
          </div>

          {/* Navigation buttons - hidden on small/medium screens, visible on large screens */}
          <div className="hidden lg:flex items-center justify-center gap-2 lg:gap-4">
            <div className="">
              <button
                onClick={prevTestimonial}
                disabled={currentIndex === 0}
                className="transition-all duration-300 ease-in-out hover:scale-110 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
              >
                <FaChevronCircleLeft size={32} />
              </button>
            </div>
            <div className="">
              <button
                onClick={nextTestimonial}
                disabled={currentIndex === maxIndex}
                className="transition-all duration-300 ease-in-out hover:scale-110 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
              >
                <FaChevronCircleRight size={32} />
              </button>
            </div>
          </div>
        </div>

        {/* Testimonials container */}
        <div className="lg:hidden">
          {/* Small and medium screens - show all cards with horizontal scroll */}
          <div className="flex overflow-x-auto lg:overflow-hidden gap-4 md:gap-5 scroll-smooth snap-x snap-mandatory">
            {testimonials.map((testimonial) => (
              <div
                key={testimonial.id}
                className="bg-white border border-gray-200 rounded-2xl p-5 sm:p-6 flex-shrink-0 w-[80%] md:w-[70%] snap-start"
              >
                <div className="flex flex-col gap-4">
                  <div className="w-32 h-12 bg-black rounded-xl flex items-center justify-center flex-shrink-0">
                    <FaQuoteLeft className="w-6 h-6 text-white" />
                  </div>

                  <div>
                    <p className="font-normal text-[#6A6A6A] tracking-[0.01em] text-sm sm:text-base md:text-[14.54px] mb-2">
                      {testimonial.quote}
                    </p>
                  </div>
                </div>

                <div className="border m-4"></div>

                <div className="flex items-center gap-4 px-4">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-14 h-14 sm:w-16 sm:h-16 rounded-full object-cover flex-shrink-0"
                  />

                  <div className="flex-1 min-w-0">
                    <h4 className="text-sm md:text-md lg:text-lg font-semibold">
                      {testimonial.name}
                    </h4>
                    <p className="flex items-center justify-between font-normal text-xs md:text-sm text-gray-500">
                      {testimonial.company}
                    </p>
                    {renderStars(testimonial.rating)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="hidden lg:block">
          {/* Large screens - show 3 cards with carousel navigation */}
          <div className="grid grid-cols-3 gap-7">
            {visibleTestimonials.map((testimonial) => (
              <div
                key={testimonial.id}
                className="bg-white border border-gray-200 rounded-2xl p-5 sm:p-6"
              >
                <div className="flex flex-col gap-4">
                  <div className="w-32 h-12 bg-black rounded-xl flex items-center justify-center flex-shrink-0">
                    <FaQuoteLeft className="w-6 h-6 text-white" />
                  </div>

                  <div>
                    <p className="font-normal text-[#6A6A6A] tracking-[0.01em] text-sm sm:text-base md:text-[14.54px] mb-2">
                      {testimonial.quote}
                    </p>
                  </div>
                </div>

                <div className="border m-4"></div>

                <div className="flex items-center gap-4 px-4">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-14 h-14 sm:w-16 sm:h-16 rounded-full object-cover flex-shrink-0"
                  />

                  <div className="flex-1 min-w-0">
                    <h4 className="text-sm md:text-md lg:text-lg font-semibold">
                      {testimonial.name}
                    </h4>
                    <p className="flex items-center justify-between font-normal text-xs md:text-sm text-gray-500">
                      {testimonial.company}
                    </p>
                    {renderStars(testimonial.rating)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeTestimonials;
